import { sessaoFetch } from '@/service/fetch'

export async function listCidadesFiltro (filtro) {
  return sessaoFetch(`base`, `/cidade?all=1&nome=${filtro}`)
}



// WEBPACK FOOTER //
// ./src/api/cidadeuf.js